import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Company } from 'companies/components';

import { verifyToken } from 'auth/actions';
import { toggleCompany, setCurrentCompanyId } from 'companies/actions';
import { eventNotTriggeredFrom } from 'lib/util';

import { addGrowlMessage, clearGrowlMessages } from 'messages/actions';
import { makeGetRoleByCompany, getUser } from 'auth/selectors';

class CompanyContainer extends Component {
  constructor(props) {
    super(props);
    this.verifyClick = eventNotTriggeredFrom(['A', 'BUTTON']);
  }

  handleToggle = (e) => {
    e.preventDefault();
    this.props
      .toggleCompany(this.props.company.id)
      .then(({ value }) => {
        this.props.addGrowlMessage(value.message, 'success', 'common.success');
        this.props.verifyToken();
      })
      .catch(
        (err) =>
          err.code !== 401 && this.props.addGrowlMessage(err.message, 'danger', 'common.error')
      );
  };

  handleDelete = (e) => this.props.handleDelete(e, this.props.company);

  handleClick = (e) => {
    this.props.company.active &&
      !this.props.company.isLoading &&
      this.verifyClick(e) &&
      this.props.setCurrentCompanyId(this.props.company) &&
      this.props.history.push(`/companies/${this.props.company.id}`);
  };

  render = () =>
    this.props.role ? (
      <Company
        company={this.props.company}
        isRoot={this.props.user.root}
        role={this.props.role}
        handleClick={this.handleClick}
        handleDelete={this.handleDelete}
        handleToggle={this.handleToggle}
        companyId={this.props.company.id}
      />
    ) : null;
}

CompanyContainer.propTypes = {
  company: PropTypes.object.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
  const getRoleByCompany = makeGetRoleByCompany();
  return {
    user: getUser(state),
    role: getRoleByCompany(state, { companyId: props.company.id }),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  toggleCompany: (companyId) => dispatch(toggleCompany(companyId)),
  addGrowlMessage: (text, type, title) => dispatch(addGrowlMessage(text, type, title)),
  clearGrowlMessages: () => dispatch(clearGrowlMessages()),
  verifyToken: () => dispatch(verifyToken()),
  setCurrentCompanyId: (company) => dispatch(setCurrentCompanyId(company)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(CompanyContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/companies/containers/CompanyContainer.js